import axios from './axios';

import { GET_PROJECT_ITEMS_API } from '../commons/constants/apis';
import { SimplifiedProjectChildItemResponseTypes } from '../types/response';
import { ResponseTypes } from '../types/response/common';
import { ProjectItemResponseTypes } from '../types/response/projectItem';

export const getProjectItemByIds = async (
  ids: number[],
  language: string
): Promise<ProjectItemResponseTypes[]> => {
  const { data }: ResponseTypes<ProjectItemResponseTypes[]> = await axios.get(
    `${GET_PROJECT_ITEMS_API}`,
    {
      params: { includeIds: ids.join(',') },
      headers: { language },
    }
  );
  return data;
};

export const getProjectItemByKey = async (key: string, language: string): Promise<any> => {
  try {
    const { data }: ResponseTypes<ProjectItemResponseTypes> = await axios.get(
      `${GET_PROJECT_ITEMS_API}/${key}`,
      { headers: { language } }
    );

    return data;
  } catch (e) {
    return { notFound: true };
  }
};

export const getProjectItemById = async (
  id: number,
  language: string
): Promise<ProjectItemResponseTypes> => {
  const { data }: ResponseTypes<ProjectItemResponseTypes> = await axios.get(
    `${GET_PROJECT_ITEMS_API}/${id}/id`,
    { headers: { language } }
  );

  return data;
};

export const getPromotionsData = async (
  id: string,
  language: string
): Promise<SimplifiedProjectChildItemResponseTypes[]> => {
  const { data }: ResponseTypes<SimplifiedProjectChildItemResponseTypes[]> = await axios.get(
    [GET_PROJECT_ITEMS_API, id, 'promotions'].join('/'),
    { headers: { language } }
  );

  return data;
};
